import { ActionIcon } from "@mantine/core";
import { IconStar, IconStarFilled } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

import { useSetFavorit } from "../../hooks/useCustomers.js";

/**
 * Der persönliche Stern an einem Kunden.
 *
 * **Der zugängliche Name nennt den Kunden.** In einer Liste mit dreißig Zeilen
 * hießen dreißig Knöpfe sonst gleich, und wer sie vorgelesen bekommt, kann sie
 * nicht auseinanderhalten. Genau diese Lage hat im Abwesenheiten-Panel den
 * e2e-Lauf gebrochen, und der strenge Locator war dort die richtige Meldung
 * (CLAUDE.md, „Ein neuer Knopf mit einem schon vergebenen Namen bricht den
 * e2e-Lauf").
 *
 * Die Farbe kommt aus einem schemafesten Token, nicht als Hexwert: Ein fester
 * Gelbton stünde im dunklen Modus falsch (CLAUDE.md, „Feste Farben im
 * Frontend gehen nicht mit dem dunklen Modus mit").
 */
export function FavoritStern({
  customerId,
  customerName,
  favorit,
}: {
  customerId: string;
  customerName: string;
  favorit: boolean;
}) {
  const { t } = useTranslation();
  const setFavorit = useSetFavorit();
  const label = favorit
    ? t("pages.customers.favoritEntfernenFuer", { name: customerName })
    : t("pages.customers.favoritSetzenFuer", { name: customerName });

  return (
    <ActionIcon
      variant="subtle"
      size="sm"
      color={favorit ? "yellow" : "gray"}
      title={label}
      aria-label={label}
      aria-pressed={favorit}
      loading={setFavorit.isPending}
      onClick={(e) => {
        // Die Zeile selbst ist verlinkt — ohne das hier öffnet der Stern den
        // Kunden, statt ihn zu markieren.
        e.stopPropagation();
        e.preventDefault();
        setFavorit.mutate({ customerId, favorit: !favorit });
      }}
    >
      {favorit ? <IconStarFilled size={16} /> : <IconStar size={16} />}
    </ActionIcon>
  );
}
